/* eslint-disable react/no-array-index-key */
import React, { useState } from 'react';
import {
  FaSearch, FaFilter, FaRedo, FaFileExport,
} from 'react-icons/fa';
import { FaBangladeshiTakaSign } from 'react-icons/fa6';
import { notify } from '../../Shared/toast';

const mockSales = [
  {
    id: 1,
    customer: 'Walk-in Customer',
    items: ['Chicken Broast Meal', 'Mango Juice'],
    amount: 400,
    status: 'Completed',
    date: '2025-06-24 12:30 PM',
    payment: 'Cash',
  },
  {
    id: 2,
    customer: 'Rahim Ahmed',
    items: ['Beef Shawarma', 'French Fries', 'Strawberry Juice'],
    amount: 450,
    status: 'Completed',
    date: '2025-06-25 01:15 PM',
    payment: 'bKash',
  },
  {
    id: 3,
    customer: 'Corporate Order',
    items: ['Chicken Broast Meal x5', 'Falafel Wrap x3', 'Mango Juice x5'],
    amount: 2900,
    status: 'Completed',
    date: '2025-06-23 11:45 AM',
    payment: 'Bank Transfer',
  },
  {
    id: 4,
    customer: 'Amina Begum',
    items: ['Chicken Burger', 'French Fries'],
    amount: 330,
    status: 'Pending',
    date: '2025-06-28 02:20 PM',
    payment: 'Cash',
  },
  {
    id: 5,
    customer: 'Walk-in Customer',
    items: ['Falafel Wrap x2'],
    amount: 400,
    status: 'Cancelled',
    date: '2025-06-27 03:45 PM',
    payment: 'N/A',
  },
];

function SalesList() {
  const [sales] = useState(mockSales);
  const [filterStatus, setFilterStatus] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [dateFilter, setDateFilter] = useState('');

  const filteredSales = sales.filter((sale) => {
    const matchesStatus = filterStatus ? sale.status === filterStatus : true;
    const lowerSearch = searchTerm.toLowerCase();
    const matchesSearch = sale.customer.toLowerCase().includes(lowerSearch)
      || sale.items.some((item) => item.toLowerCase().includes(lowerSearch));
    const matchesDate = dateFilter ? sale.date.includes(dateFilter) : true;
    return matchesStatus && matchesSearch && matchesDate;
  });

  const statusBadge = (status) => {
    const colors = {
      Completed: 'bg-green-100 text-green-800',
      Pending: 'bg-yellow-100 text-yellow-800',
      Cancelled: 'bg-red-100 text-red-800',
    };
    return (
      <span className={`px-2 py-1 rounded-full text-xs font-medium ${colors[status]}`}>
        {status}
      </span>
    );
  };

  return (
    <div className="p-6 bg-gray-50 min-h-screen">
      <h2 className="text-2xl font-bold text-gray-800 mb-6">Sales History</h2>

      {/* Filters */}
      <div className="bg-white rounded-xl shadow-md p-6 mb-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
          <div className="relative">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <FaSearch className="text-gray-400" />
            </div>
            <input
              type="text"
              placeholder="Search by customer or item"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="pl-10 w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-red-500 focus:border-red-500 outline-none transition"
            />
          </div>

          <div>
            <div className="flex items-center">
              <FaFilter className="text-gray-400 mr-2" />
              <select
                value={filterStatus}
                onChange={(e) => setFilterStatus(e.target.value)}
                className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-red-500 focus:border-red-500 outline-none transition"
              >
                <option value="">All Status</option>
                <option value="Completed">Completed</option>
                <option value="Pending">Pending</option>
                <option value="Cancelled">Cancelled</option>
              </select>
            </div>
          </div>

          <div>
            <input
              type="date"
              value={dateFilter}
              onChange={(e) => setDateFilter(e.target.value)}
              className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-red-500 focus:border-red-500 outline-none transition"
            />
          </div>

          <div className="flex space-x-2">
            <button
              type="button"
              onClick={() => {
                setFilterStatus('');
                setSearchTerm('');
                setDateFilter('');
              }}
              className="flex items-center justify-center bg-gray-200 hover:bg-gray-300 text-gray-800 px-4 py-2 rounded-lg transition-colors"
            >
              <FaRedo className="mr-2" />
              {' '}
              Reset
            </button>
            <button
              type="button"
              className="flex items-center justify-center bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg transition-colors"
              onClick={() => {
                notify.info('Export functionality is not implemented yet.');
              }}
            >
              <FaFileExport className="mr-2" />
              {' '}
              Export
            </button>
          </div>
        </div>
      </div>

      {/* Sales Table */}
      <div className="bg-white rounded-xl shadow-md overflow-hidden">
        <div className="overflow-x-auto">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">#</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Customer</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Items</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Amount</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Payment</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Date & Time</th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {filteredSales.map((sale, index) => (
                <tr key={sale.id} className="hover:bg-gray-50">
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{index + 1}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{sale.customer}</td>
                  <td className="px-6 py-4 text-sm text-gray-500">
                    <ul className="list-disc list-inside">
                      {sale.items.map((item, i) => (
                        <li key={i}>{item}</li>
                      ))}
                    </ul>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 font-medium flex items-center">
                    <FaBangladeshiTakaSign className="mr-1" />
                    {' '}
                    {sale.amount.toLocaleString()}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{sale.payment}</td>
                  <td className="px-6 py-4 whitespace-nowrap">{statusBadge(sale.status)}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{sale.date}</td>
                </tr>
              ))}
              {filteredSales.length === 0 && (
                <tr>
                  <td colSpan="7" className="px-6 py-4 text-center text-sm text-gray-500">
                    No sales records found matching your criteria.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default SalesList;
